import {
  Modal,
  Form,
  FormGroup,
  ModalBody,
  Col,
  Label,
  Input,
  ModalHeader,
  ModalFooter,
} from "reactstrap";

import React, { useRef } from 'react';
import { useMemo } from "react";
import { getPrimaryButtonClass } from "helpers/sf_utils";
import { useDispatch } from "react-redux";
import { updateCustomizeColumnsOrder } from "store/customize-columns-order/actions";
import useFeatureFlags from "hooks/useFeatureFlags";

const CustomizeColumnsModal = ({ pageName, modalState, setModalState, onSubmitModalState, handleColumns, onClickModalClose, id, canBeDisabled, dragndropFeatureFlag, isNewCustomizeColumnApproach = false }) => {
  const dragItem = useRef(null);
  const dragOverItem = useRef(null);
  
  const dispatch = useDispatch();
  const [isFeatureFlagActive] = useFeatureFlags();

  const isDisabledSaveButton = useMemo(() => {
    return modalState?.columns?.reduce((acc, curr) => {
      if (!curr?.hidden) {
        acc = false;
      }
      return acc;
    }, true);
  }, [modalState?.columns]);

  const handleSort = () => {
    let customizeColumns = [...modalState?.columns];
    const draggedItemContent = customizeColumns.splice(dragItem.current, 1)[0];
    customizeColumns.splice(dragOverItem.current, 0, draggedItemContent);
    dragItem.current = null;
    dragOverItem.current = null;
    setModalState({ ...modalState, columns: customizeColumns });
  };

  const saveCustomizeColumnsOrder = () => {
    let data = [];
    modalState?.columns?.map((singe_obj, index) => {
      data.push({
        columnName: singe_obj.columnName,
        position: index + 1,
      });
    });
    if (isFeatureFlagActive(dragndropFeatureFlag) && !isNewCustomizeColumnApproach) {
      dispatch(updateCustomizeColumnsOrder({ page_name: pageName, data: data }));
    }
  };

  const handleCustomizeColumnsSubmit = () => {
    onSubmitModalState(modalState?.columns);
    saveCustomizeColumnsOrder();
  };

  return (
    <Modal
      className="customize-columns admin-users modal-dialog-scrollable"
      id={id}
      toggle={onClickModalClose}
      isOpen={modalState.isActiveModal}
      backdrop={true}
      backdropClassName="no-backdrop-color"
      fade={false}
    >
      <ModalHeader>
        <span className="modal-title text-black">Customize Columns</span>
        <button type="button" className="close" onClick={onClickModalClose} data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&time;</span>
        </button>
      </ModalHeader>
      <ModalBody className="bg-white py-0">
        <Form className="sf-custom-column-position-relative">
          {modalState?.columns &&
            modalState?.columns.map((singe_obj, index) => {
              return (
                <FormGroup
                  className="mt-2"
                  key={index}
                  row
                  check
                >
                  <Col sm={{ size: 10 }}>
                    <Input
                      id={`${singe_obj.dataField}-customimze-columns`}
                      type="checkbox"
                      name={singe_obj.text}
                      onChange={() => {}}
                      value={singe_obj.hidden}
                      onClick={() => handleColumns(singe_obj)}
                      checked={!singe_obj.hidden}
                    />
                    <Label
                      htmlFor={`${singe_obj.dataField}-customimze-columns`}
                      check
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        width: '100%',
                        cursor: 'move',
                      }}
                      draggable={isFeatureFlagActive(dragndropFeatureFlag)}
                      onDragStart={(e) => (dragItem.current = index)}
                      onDragEnter={(e) => (dragOverItem.current = index)}
                      onDragEnd={handleSort}
                      onDragOver={(e) => e.preventDefault()}
                    >
                      <span
                        style={{
                          flexGrow: 1,
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          cursor: 'pointer',
                        }}
                        title={singe_obj.text}
                      >
                        {singe_obj.text}
                      </span>
                      {isFeatureFlagActive(dragndropFeatureFlag) && (
                        <i
                          className="bx bx-menu font-size-18 align-middle"
                          style={{
                            flexShrink: 0,
                            color: '#C0C8CD',
                          }}
                          id="customize-column-drag-and-drop"
                          title="Drag to rearrange columns"
                        />
                      )}
                    </Label>
                  </Col>
                </FormGroup>
              );
            })}
        </Form>
      </ModalBody>
      <ModalFooter>
        <button
          className={`btn ${getPrimaryButtonClass()} btn-sm`}
          type="submit"
          disabled={canBeDisabled && isDisabledSaveButton}
          onClick={() => handleCustomizeColumnsSubmit()}
        >
          Save
        </button>
        <button className="btn btn-light btn-sm" type="reset" onClick={onClickModalClose}>
          Cancel
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default CustomizeColumnsModal;